import { DEFAULT_PRIMARY } from '@/lib/brand-theme';
import { hslStringToObj, hslToHex } from '@/lib/hsl-color';

export type NativeSafeAreaChromeMode = 'primary' | 'background';

let chromeMode: NativeSafeAreaChromeMode = 'background';

/**
 * Push the current chrome color to the native shell so the status bar and
 * home-indicator safe areas match the visible page chrome.
 *
 * Pass `mode` when entering/leaving the dashboard shell (primary header).
 * Omit it to refresh using the current mode (theme / brand color changes).
 */
export function notifyNativeSafeAreaTheme(mode?: NativeSafeAreaChromeMode) {
  if (typeof window === 'undefined' || !window.ReactNativeWebView?.postMessage) return;

  if (mode) chromeMode = mode;

  const isDark = document.documentElement.classList.contains('dark');
  const primaryTriplet =
    getComputedStyle(document.documentElement).getPropertyValue('--primary').trim() ||
    DEFAULT_PRIMARY;
  const backgroundTriplet =
    getComputedStyle(document.documentElement).getPropertyValue('--background').trim() ||
    (isDark ? '240 10% 6%' : '240 8% 95%');

  const chromeTriplet = chromeMode === 'primary' ? primaryTriplet : backgroundTriplet;
  const backgroundColor = hslToHex(chromeTriplet);
  const statusBarStyle = hslStringToObj(chromeTriplet).l > 55 ? 'dark' : 'light';

  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: 'SAFE_AREA_THEME',
      backgroundColor,
      statusBarStyle,
    })
  );
}
